<div class="mat-modal-dialog cancel-modal p-0">
    <h2 mat-dialog-title>
        <mat-icon
            style="color:red; float: right; cursor: pointer; position: relative; top: 12px; left: 11px; font-size: 20px;"
            (click)="dialogRef.close('')">close</mat-icon>
    </h2>
    <mat-dialog-content>
        <p class="logout"
            style="text-align: center; color:#000000DE; font-family: poppins; font-size: 16px; font-weight: 500!important;">
            Do you want
            to logout ?</p>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button type="button"
            style="border: none; font-size: 15px; font-weight: 500 !important; font-family: 'poppins';"
            class="btn footerBtn funcBtn" (click)="dialogRef.close('yes')">Yes</button>
        <button type="button"
            style="border: none; font-size: 15px; font-weight: 500 !important; font-family: 'poppins';"
            class="btn footerBtn cancel" (click)="dialogRef.close('')">No</button>
    </div>
</div>